import Splide from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';
import { MyTransition } from './splide-transition';

const commonGalleryOptions = {
    accessibility: true,
    drag: false,
    // @ts-ignore
    pagination: true,
    // @ts-ignore
    slideFocus: false,
    easing: 'linear',
    speed: 600,
    interval: 5000,
    focus: 0,
    omitEnd: true,
    gap: '2rem',
    padding: {
        left: '0rem',
        right: '0rem'
    },
    arrows: true,
    keyboard: 'focused',
    video: {
        // setting to true is currently required due to a bug in the splide video extension creating
        // the embed url with an empty "playlist" parameter which break YouTube embed link
        loop: true
    },
    classes: {
        pagination: 'splide__pagination gallery-pagination gallery-pagination-nums',
        page: 'splide__pagination__page gallery-page'
    },

}


const galleryOptions = (perPage: number) => ({
    perPage: perPage,
    perMove: 1,
    breakpoints: {
        1280: {
            perPage: Math.max(1, Math.floor(perPage / 2)),
            perMove: 1,
            gap: '1.5rem',
        },
        767: {
            perPage: 1,
            perMove: 1,
            gap: '1rem',
        }
    },
    updateOnMove: true,
    autoHeight: true,
    type: 'slide',

})

const quoteGalleryOptions = (perPage: number) => ({
    perPage: perPage,
    perMove: 1,
    breakpoints: {
        1280: {
            perPage: Math.max(1, Math.floor(perPage / 2)),
            perMove: 1,
            gap: '2.5rem'
        },
        767: {
            perPage: 1,
            perMove: 1,
            gap: '1.5rem'
        }
    },
    updateOnMove: true,
    autoHeight: true,
    type: 'slide',
})

export class Gallery {
    gallery: Splide;
    galleryType: string;
    galleryOptions: any;//Refer to splide options documentationt for available choices
    autoStart: string;
    setInterval: string;
    progressBar: HTMLElement;
    galleryElement: HTMLElement;
    controlsObserver: MutationObserver;
    pageWidth: number;
    constructor(element: HTMLElement) {
        this.galleryElement = element;
        this.galleryType = element.getAttribute('data-gallery-type');
        this.autoStart = element.getAttribute('data-autoplay') != null ? element.getAttribute('data-autoplay') : "";
        // This needs to be set to a obscenely large number due to an interval bug with Splide
        this.setInterval = element.getAttribute('data-interval') != null ? element.getAttribute('data-interval') : "1000000";
        this.setGalleryOptions();
        this.gallery = new Splide(element, this.galleryOptions);
        this.gallery.on('mounted', () => {
            this.arrowDisplay();
            setTimeout(() => {
                const playButtons = Array.prototype.slice.call(this.gallery.root.querySelectorAll('.media-gallery-item .splide__slide__container--has-video'));
                playButtons.forEach(playButton => {
                    const slide = playButton.closest('.splide__slide');
                    const slideTarget = slide.querySelector('[data-gallery-video]');
                    slideTarget.append(playButton);
                });
            }, 1000);//Forgive me, but no event to listen to find out when the playbuttons are loaded. Splide also isn't respecting the splide__slide__container for the playbutton target so I had to do it manually here :(
        });
        this.pageWidth = document.documentElement.offsetWidth;
        this.gallery.on('resized', () => {
            // page width check prevents the carousel from resetting after a few seconds on load, when a resize is called from elsewhere
            const currentPageWidth = this.pageWidth;
            this.pageWidth = document.documentElement.offsetWidth;
            if (currentPageWidth != this.pageWidth) {
                this.arrowDisplay();
                this.handleBreakpointChange();
            }
        });
        this.gallery.on('move', () => {
            this.gallery.root.classList.add('moving');
        });
        this.gallery.on('moved', () => {
            this.gallery.root.classList.remove('moving');
        });

        this.gallery.on('video:play', () => {
            const videoSelector = ".is-playing .is-active .splide__video__wrapper";
            const playingVideoElement = document.querySelector(`${videoSelector} video`) || document.querySelector(`${videoSelector} iframe`);
            if (playingVideoElement) {
                playingVideoElement.setAttribute('title', playingVideoElement.closest('[data-video-title]').getAttribute('data-video-title'));
            }

        });

        this.gallery.mount({ Video }, MyTransition);
    }

    arrowDisplay = () => {
        const galleryArrows = this.gallery.Components.Arrows.arrows;
        if (galleryArrows.next && galleryArrows.prev) {
            const arrowsShouldBeHidden = galleryArrows.next.hasAttribute('disabled') && galleryArrows.prev.hasAttribute('disabled');
            galleryArrows.next.hidden = arrowsShouldBeHidden;
            galleryArrows.prev.hidden = arrowsShouldBeHidden;

        }
    }
    setGalleryOptions = () => {
        let optionsToUse: any = galleryOptions;
        const defaultPerPage = this.galleryType === "quote" ? 2 : 4;
        const parsedPerPage = this.galleryElement != null ? parseInt(this.galleryElement.getAttribute('data-grid-size')) : NaN;
        const perPage = Number.isFinite(parsedPerPage) && parsedPerPage > 0 ? parsedPerPage : defaultPerPage;

        if (this.galleryType === "quote") {
            optionsToUse = quoteGalleryOptions(perPage);
        }
        else {
            optionsToUse = galleryOptions(perPage);
        }
        const autoPlayOptions = {
            autoplay: this.autoStart.toString(),
            interval: this.setInterval.toString()
        }
        this.galleryOptions = {
            ...commonGalleryOptions,
            ...autoPlayOptions,
            ...optionsToUse
        }
    }

    handleBreakpointChange = () => {
        const perPage = this.gallery.options.perPage as number;
        const currentIndex = this.gallery.index;
        const totalSlides = this.gallery.length;

        // Snap to nearest valid page boundary if needed
        if (perPage > 1) {
            const remainder = currentIndex % perPage;
            if (remainder !== 0) {
                // Calculate nearest page boundary
                const currentPage = Math.floor(currentIndex / perPage);
                const lastPage = Math.floor((totalSlides - 1) / perPage);
                const targetPage = Math.min(currentPage, lastPage);
                const targetIndex = targetPage * perPage;

                // Snap instantly without animation
                const originalSpeed = this.gallery.options.speed;
                this.gallery.options.speed = 0;
                this.gallery.go(targetIndex);
                setTimeout(() => {
                    this.gallery.options.speed = originalSpeed;
                }, 0);
            }
        }
    }
}